import {
	allColorShades,
	ColorsSchemeType,
	ColorsType,
	relations,
} from '../colors'
import { createRelationObj } from '../colors/utils'
import { Button_Shape } from '../buttons/types'

export const createTheme = (theme: ColorsSchemeType): ColorsSchemeType => {
	return createRelationObj(theme, relations)
}

export type ThemeType = {
	colors?: ColorsType | typeof allColorShades
	font?: {
		main: string
		head: string
		weights_head?: number[]
		family_head?: string
		weights_main?: number[]
		family_main?: string
	}
	fontStretch?: string
	gradients?: { [key: string]: string }
	buttonShape?: Button_Shape
	borderRadius?: 0 | 4 | 8 | 16 | 24
}
